import { render, staticRenderFns } from "./AlterarTelefone.vue?vue&type=template&id=35584850"
import script from "./AlterarTelefone.vue?vue&type=script&lang=ts"
export * from "./AlterarTelefone.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports